import { BehaviorSubject, Observable } from 'rxjs';

export class StorageHandler {
    static PREFIX = 'ng2WebStorage_';
    static _instance: Map<string, StorageHandler> = new Map();

    public get type(): string {
        return this._type;
    }

    protected _cache$: Map<string, BehaviorSubject<number>> = new Map();
    protected _newKey$: BehaviorSubject<string> = new BehaviorSubject('');

    private _storage: Storage;
    private _type: string;

    constructor(webStorage: Storage) {
        const type = webStorage === localStorage ? 'local' : 'session';

        if (StorageHandler._instance.get(type)) {
            return StorageHandler._instance.get(type);
        }
        StorageHandler._instance.set(type, this);

        this._storage = webStorage;
        this._type = type + '_';

        const onStorage = (e: any) => {
            if (this.isFullKey(e.key)) {
                if (!this.exists(e.key)) {
                    this.newCache(e.key, e.newValue);
                } else {
                    this.set$(e.key, e.newValue);
                }
            }
        };

        window.addEventListener('storage', onStorage, false);
    }

    public isFullKey(key: string) {
        return key.startsWith(StorageHandler.PREFIX + this._type);
    }

    public generateStorageKey(key: string): string {
        return StorageHandler.PREFIX + this._type + key;
    }

    public exists(fullkey: string): boolean {
        return !!this._cache$.get(fullkey);
    }

    public getKey$(): Observable<string> {
        return this._newKey$.asObservable();
    }

    public get$(key: string): Observable<any> {
        let fullkey: string;
        fullkey = this.isFullKey(key) ? key : this.generateStorageKey(key);

        if (!this.exists(fullkey)) {
            this.newCache(fullkey);
        }

        return this._cache$.get(fullkey).asObservable();
    }

    public get(key: string): any {
        const storageKey = this.generateStorageKey(key);
        const value = <string>this._storage.getItem(storageKey);

        this.set$(storageKey, value);

        return this.getGettable(value);
    }

    public set(key: string, value: any): void {
        const storageKey = this.generateStorageKey(key);
        const setterValue = this.getSettable(value);

        this._storage.setItem(storageKey, setterValue);

        this.set$(storageKey, setterValue);
    }

    public onChange(): void {
        return;
    }

    public remove(key: string): void {
        const storageKey = this.generateStorageKey(key);
        this._storage.removeItem(storageKey);
    }

    protected set$(fullkey: string, data: any) {
        if (!this._cache$.get(fullkey)) {
            this.newCache(fullkey, data);
        }
        if (this._cache$.get(fullkey).getValue() !== data) {
            this._cache$.get(fullkey).next(data);
        }
    }

    private getSettable(value: any): string {
        return typeof value === 'string' ? value : JSON.stringify(value);
    }

    private getGettable(value: string): any {
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }

    private newCache(fullkey: string, data?: any) {
        this._cache$.set(fullkey, new BehaviorSubject(data));
        this._newKey$.next(fullkey);
    }
}
